import React from "react";

import Box from "./Box";
import DesktopProductImage from "./DesktopProductImage";
import DashHeading from "./DashHeading";
import PropTypes from "prop-types";

function ProductImagesBrand({ images }) {
  return (
    <Box>
      <Box mt={20} mb={40}>
        <DashHeading heading="Brand gallery" />
      </Box>
      <Box
        display={["none", null, "grid", null]}
        gridTemplateColumns="1fr 1fr 1fr"
        gridRowGap={20}
        gridColumnGap={20}
      >
        {images.map((image) => {
          return (
            <DesktopProductImage
              key={image.url}
              image={image}
              sizes="25vw"
              buttonStyle="small"
            />
          );
        })}
      </Box>
    </Box>
  );
}

ProductImagesBrand.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      width: PropTypes.string.isRequired,
      height: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ProductImagesBrand;
